// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { Api } from "../Api/Api";

// export default function LoginPage() {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const navigate = useNavigate();

//   const handleLogin = async () => {
//     try {
//       const { data } = await axios.post(`${Api}admin/login.php`, {
//         username,
//         password,
//       });

//       localStorage.setItem("token", data.token);
//       localStorage.setItem(
//         "currentUser",
//         JSON.stringify({
//           type: "admin",
//           username: data.admin.username,
//           id: data.admin.id,
//         })
//       );

//       // Directly go to the correct dashboard route
//       navigate("/admin/dashboard", { replace: true });
//     } catch (error) {
//       console.error("Login error:", error);
//       alert("Invalid credentials");
//     }
//   };

//   // ✅ Redirect if already logged in
//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (token) navigate("/admin/dashboard", { replace: true });
//   }, [navigate]);

//   // ✅ If already logged in, redirect to dashboard
//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (token) navigate("/dashboard", { replace: true });
//   }, []);

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-yellow-100 via-orange-100 to-yellow-200 px-4">
//       <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md p-8 relative overflow-hidden">
//         {/* Decorative Bag Logo */}
//         <div className="absolute -top-10 -right-10 bg-yellow-400 w-32 h-32 rounded-full blur-2xl opacity-40"></div>
//         <div className="absolute -bottom-10 -left-10 bg-orange-400 w-32 h-32 rounded-full blur-2xl opacity-40"></div>

//         <div className="text-center mb-8">
//           <h1 className="text-3xl font-extrabold text-yellow-700">
//            Sri Murugan Traders
//           </h1>
//           <p className="text-gray-600 mt-1">Admin Login Portal</p>
//         </div>

//         <div className="mb-5">
//           <label
//             className="block text-sm font-semibold text-gray-700 mb-1"
//             htmlFor="username"
//           >
//             Admin Username
//           </label>
//           <input
//             id="username"
//             value={username}
//             onChange={(e) => setUsername(e.target.value)}
//             placeholder="Enter admin username"
//             className="w-full px-4 py-2 border-2 border-yellow-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-yellow-500"
//           />
//         </div>

//         <div className="mb-6">
//           <label
//             className="block text-sm font-semibold text-gray-700 mb-1"
//             htmlFor="password"
//           >
//             Password
//           </label>
//           <input
//             id="password"
//             type="password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             placeholder="Enter password"
//             className="w-full px-4 py-2 border-2 border-yellow-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-yellow-500"
//           />
//         </div>

//         <button
//           onClick={handleLogin}
//           className="w-full py-3 bg-yellow-600 hover:bg-yellow-700 text-white rounded-xl font-bold shadow-md transition duration-300"
//         >
//           Login as Admin
//         </button>
//       </div>
//     </div>
//   );
// }






// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { Api } from "../Api/Api";



// export default function LoginPage() {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault(); // Prevent form submission refresh
//     setLoading(true);
//     try {
//       const { data } = await axios.post(`${Api}admin/login.php`, {
//         username,
//         password,
//       });

//       localStorage.setItem("token", data.token);
//       localStorage.setItem(
//         "currentUser",
//         JSON.stringify({
//           type: "admin",
//           username: data.admin.username,
//           id: data.admin.id,
//         })
//       );

//       navigate("/admin/dashboard", { replace: true });
//     } catch (error) {
//       console.error("Login error:", error);
//       alert("Invalid credentials. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (token) navigate("/admin/dashboard", { replace: true });
//   }, [navigate]);

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-[#f8fafc] font-['Inter',_sans-serif] px-4">
//       <div className="w-full max-w-[400px]">
//         {/* Brand Identity */}
//         <div className="text-center mb-10">
          
//           <h1 className="text-2xl font-bold text-slate-900 tracking-tight">
//             Sri Murugan Traders
//           </h1>
//           <p className="text-slate-500 text-sm mt-2">
//             Management Portal Access
//           </p>
//         </div>

//         <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-8">
//           <form onSubmit={handleLogin} className="space-y-5">
//             <div>
//               <label
//                 className="block text-sm font-medium text-slate-700 mb-1.5"
//                 htmlFor="username"
//               >
//                 Username
//               </label>
//               <input
//                 id="username"
//                 type="text"
//                 required
//                 value={username}
//                 onChange={(e) => setUsername(e.target.value)}
//                 placeholder="Enter your username"
//                 className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-slate-900 text-sm transition-all focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500"
//               />
//             </div>

//             <div>
//               <div className="flex justify-between mb-1.5">
//                 <label
//                   className="block text-sm font-medium text-slate-700"
//                   htmlFor="password"
//                 >
//                   Password
//                 </label>
//               </div>
//               <input
//                 id="password"
//                 type="password"
//                 required
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 placeholder="••••••••"
//                 className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-slate-900 text-sm transition-all focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500"
//               />
//             </div>

//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full py-2.5 bg-slate-900 hover:bg-slate-800 disabled:bg-slate-400 text-white rounded-lg font-semibold text-sm transition duration-200 shadow-sm mt-2"
//             >
//               {loading ? "Signing in..." : "Sign in to Dashboard"}
//             </button>
//           </form>
//         </div>

//         <p className="text-center text-slate-400 text-xs mt-8">
//           &copy; {new Date().getFullYear()} Sri Murugan Traders. All rights
//           reserved.
//         </p>
//       </div>
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Api } from "../Api/Api";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${Api}admin/login.php`, {
        username,
        password,
      });

      localStorage.setItem("token", data.token);
      localStorage.setItem(
        "currentUser",
        JSON.stringify({
          type: "admin",
          username: data.admin.username,
          id: data.admin.id,
        })
      );

      navigate("/admin/dashboard", { replace: true });
    } catch (error) {
      console.error("Login error:", error);
      alert("Invalid credentials. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) navigate("/admin/dashboard", { replace: true });
  }, [navigate]);

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 font-['Inter',_sans-serif]
    bg-gradient-to-br from-indigo-50 via-white to-blue-50 relative overflow-hidden"
    >
      {/* Background glow blobs */}
      <div className="absolute -top-32 -left-32 w-96 h-96 bg-indigo-200/30 rounded-full blur-3xl"></div>
      <div className="absolute top-1/3 -right-40 w-96 h-96 bg-blue-200/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-1/2 w-[500px] h-[300px] bg-purple-200/20 rounded-full blur-3xl -translate-x-1/2"></div>

      <div className="w-full max-w-[400px] relative z-10">
        {/* Brand */}
        <div className="text-center mb-10">
          {/* LOGO */}
          <img
            src="/logo.jpg"
            alt="Sri Murugan Traders"
            className="mx-auto w-24 h-24 object-contain mb-4 drop-shadow-lg"
          />

          <h1 className="text-2xl font-bold text-slate-900 tracking-tight">
            Sri Murugan Traders
          </h1>
          <p className="text-slate-500 text-sm mt-2">
            Management Portal Access
          </p>
        </div>

        {/* Login Card */}
        <div className="bg-white/80 backdrop-blur border border-slate-200 rounded-2xl shadow-lg p-8">
          <form onSubmit={handleLogin} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">
                Username
              </label>
              <input
                type="text"
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter your username"
                className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-slate-900 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">
                Password
              </label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg text-slate-900 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-2.5 bg-slate-900 hover:bg-slate-800 disabled:bg-slate-400 text-white rounded-lg font-semibold text-sm transition shadow-md"
            >
              {loading ? "Signing in..." : "Sign in to Dashboard"}
            </button>
          </form>
        </div>

        <p className="text-center text-slate-400 text-xs mt-8">
          &copy; {new Date().getFullYear()} Sri Murugan Traders. All rights
          reserved.
        </p>
      </div>
    </div>
  );
}
